import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { CardContent } from '@/components/ui/card';
import Editor, {
  BtnItalic,
  BtnBold,
  Toolbar,
  BtnLink,
} from 'react-simple-wysiwyg';
import { API } from '@/utils/API';

const NewBannerMessagePage: React.FC = () => {
  const [message, setMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submissionError, setSubmissionError] = useState('');
  const [submissionSuccess, setSubmissionSuccess] = useState('');

  const handleSave = async () => {
    if (!message || message.trim() === '' || message === '<br>') {
      setSubmissionError('Please enter a message');
      return;
    }

    setIsSubmitting(true);
    setSubmissionError('');
    setSubmissionSuccess('');

    try {
      const response = await API.authenticated.admin.fetch('/banner_messages', {
        method: 'POST',
        body: JSON.stringify({
          banner_message: {
            message: message,
          },
        }),
      });

      const responseData = await response.json();

      if (!response.ok) {
        throw new Error(
          responseData.message ||
            responseData.errors?.join(', ') ||
            'Failed to create banner message'
        );
      }

      setSubmissionSuccess('Message posted successfully');
      setMessage('');
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : 'An unexpected error occurred';
      setSubmissionError(errorMessage);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex justify-center p-4">
      <div className="w-full max-w-4xl">
        <CardContent>
          <div className="space-y-4">
            <div>
              <label className="text-sm font-medium text-gray-700 mb-2 block">
                Message
              </label>
              <Editor
                value={message}
                onChange={event => setMessage(event.target.value)}
              >
                <Toolbar>
                  <BtnBold />
                  <BtnItalic />
                  <BtnLink />
                </Toolbar>
              </Editor>
            </div>

            <Button
              type="button"
              className="w-full"
              onClick={handleSave}
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Posting...' : 'Post'}
            </Button>

            {submissionSuccess && (
              <div className="bg-green-50 border border-green-200 rounded-lg p-4">
                <p className="text-green-800 text-sm">{submissionSuccess}</p>
              </div>
            )}

            {submissionError && (
              <div className="bg-red-50 border border-red-200 rounded-lg p-4">
                <p className="text-red-800 text-sm">{submissionError}</p>
              </div>
            )}
          </div>
        </CardContent>
      </div>
    </div>
  );
};

export default NewBannerMessagePage;
